import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.regexp.replace";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/yangwei/work/project/cat_help_admin/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.sort";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/Users/yangwei/work/project/cat_help_admin/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import constantMall from "@/const/constantMall";
import * as echarts from "echarts";
// import chinaMap from "echarts/map/json/china.json";  //中国地图
import chinaMap from "@/util/china.json"; //中国地图
import { mapGetters } from 'vuex';
import { getStatistics as getStatisticsGoodsSpu } from '@/api/mall/goodsspu';
import { getStatistics as getStatisticsOrderInfo, getStatisticsByColumn as getStatisticsByColumnOrderInfo } from '@/api/mall/orderinfo';
import { getStatistics as getStatisticsUserInfo, getStatisticsByColumn as getStatisticsByColumnUserInfo } from '@/api/mall/userinfo';
import { getStatistics as getStatisticsShopUser } from '@/api/mall/usershop';
import { getList as _getWxAppList, getObj as getWxApp } from '@/api/wxmp/wxapp';
import { getMaCode as _getMaCode } from '@/api/wxma/wxapp';
import { h5HostMobile, h5HostPC } from '@/config/env.js';
import { getStore } from '@/util/store';
import { getCount as userOnlineCount } from '@/api/mall/useronline';
export default {
  name: 'wel',
  data: function data() {
    return {
      option1: {
        data: [{
          click: function click(item) {
            // alert(JSON.stringify(item))
          },
          title: '新增商品',
          subtitle: '今天',
          count: 0,
          allcount: 0,
          text: '当前商品总数量',
          color: '#165dff',
          key: '商'
        }, {
          click: function click(item) {
            // alert(JSON.stringify(item));
          },
          title: '新增用户',
          subtitle: '今天',
          count: 0,
          allcount: 0,
          text: '当前用户总数量',
          color: '#00B42A',
          key: '用'
        }, {
          click: function click(item) {
            // alert(JSON.stringify(item));
          },
          title: '新增订单',
          subtitle: '今天',
          count: 0,
          allcount: 0,
          text: '已付款订单总数量',
          color: '#722ED1',
          key: '订'
        }]
      },
      filterText: '',
      treeWxAppProps: {
        label: 'name',
        value: 'id'
      },
      treeWxAppData: [],
      appId: null,
      startDate: this.$moment().add(-7, 'days').format('YYYY-MM-DD'),
      endDate: this.$moment().add(-1, 'days').format('YYYY-MM-DD'),
      currentDataViewFilter: "",
      xAxisData: [],
      myChart: null,
      wxAppData: [],
      dialogWxApp: false,
      wxApp: {},
      h5HostMobile: h5HostMobile,
      h5HostPC: h5HostPC,
      dialogQrCode: false,
      qrCodeScene: '',
      codeType: '',
      userOnlineCount: 0,
      //商城在线用户总数，不包括管理用户
      userOnlineData: [],
      //商城在线用户统计
      userOnlineUpdateDate: this.$moment().format('YYYY-MM-DD hh:mm:ss'),
      //商城在线用户统计更新时间
      userOnlineLoadData: true // 避免反复请求数据，引起数据错乱
    };
  },

  computed: _objectSpread({}, mapGetters(['website', 'userInfo'])),
  watch: {
    filterText: function filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  created: function created() {
    var _this = this;
    this.getMallSummary();
    if (this.userInfo.type == '1' || this.userInfo.type == '-1') {
      this.getWxAppList();
    }
    var userAgent = navigator.userAgent;
    var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1;
    var isSafari = userAgent.indexOf("Chrome") == -1 && userAgent.indexOf("Safari") > -1;
    if (isIE || isSafari) {
      setTimeout(function () {
        _this.$notify({
          title: '浏览器兼容',
          message: '请使用谷歌、火狐、360极速等主流浏览器进行操作，否则页面可能出现未知错误！',
          duration: 0,
          type: 'warning'
        });
      }, 500);
    }
    this.getUserOnlineStatistics();
  },
  methods: {
    //加载公众号列表
    getWxAppList: function getWxAppList() {
      var _this2 = this;
      _getWxAppList({
        appType: '2'
      }).then(function (response) {
        var data = response.data;
        _this2.treeWxAppData = data;
      }).catch(function () {});
    },
    // 各端用户在线统计
    getUserOnlineStatistics: function getUserOnlineStatistics() {
      var _this3 = this;
      // 必须得上一次请求完成才能再次请求，避免数据显示错乱
      if (this.userOnlineLoadData) {
        this.userOnlineLoadData = false;
        this.userOnlineUpdateDate = this.$moment().format('YYYY-MM-DD HH:mm:ss');
        var count = 0;
        this.userOnlineCount = 0;
        this.userOnlineData = [];
        var objLength = Object.keys(constantMall.clientType).length;
        var _loop = function _loop(clientType) {
          userOnlineCount(clientType).then(function (response) {
            var data = response.data.data;
            _this3.userOnlineData.push(_objectSpread(_objectSpread({}, constantMall.clientType[clientType]), {}, {
              name: constantMall.clientType[clientType].title,
              key: clientType,
              value: data
            }));
            _this3.userOnlineCount = _this3.userOnlineCount + data;
            count++;
            if (count === objLength) {
              //必须设置一个排序函数 a-b升序  b-a降序
              _this3.userOnlineData.sort(function (a, b) {
                return b.value - a.value;
              });
              _this3.userOnlineChartShow(_this3.userOnlineData);
              _this3.userOnlineLoadData = true;
            }
          }).catch(function () {
            _this3.userOnlineLoadData = true;
          });
        };
        for (var clientType in constantMall.clientType) {
          _loop(clientType);
        }
      } else {
        this.$message.info('数据正在加载中，请稍后...');
      }
    },
    userOnlineChartShow: function userOnlineChartShow(data) {
      var chartDom = document.getElementById('userOnlineChart');
      var myChart = echarts.init(chartDom);
      var option;
      option = {
        title: {
          text: '各端用户在线统计',
          //主标题
          x: 'center',
          textStyle: {
            fontSize: '15'
          }
        },
        legend: {
          orient: 'vertical',
          left: 'left',
          top: 'middle',
          padding: 50
        },
        tooltip: {
          trigger: 'item'
        },
        series: [{
          name: '各端用户在线统计',
          type: 'pie',
          top: 20,
          radius: ['40%', '70%'],
          data: data
        }]
      };
      option && myChart.setOption(option);
    },
    // 商城统计
    getMallSummary: function getMallSummary() {
      var _this4 = this;
      getStatisticsGoodsSpu().then(function (response) {
        var data = response.data.data;
        _this4.option1.data[0].count = data.countToday;
        _this4.option1.data[0].allcount = data.countTotal;
      }).catch(function () {});
      if (this.userInfo.type == '1' || this.userInfo.type == '-1') {
        getStatisticsUserInfo().then(function (response) {
          var data = response.data.data;
          _this4.option1.data[1].count = data.countToday;
          _this4.option1.data[1].allcount = data.countTotal;
        }).catch(function () {});
        // 用户来源端比例
        getStatisticsByColumnUserInfo('app_type', {}).then(function (response) {
          var data = response.data.data;
          data = data.map(function (item) {
            return {
              name: constantMall.clientType[item.name].title || item.name,
              value: item.value
            };
          });
          // 基于准备好的dom，初始化echarts实例
          var statisticsAppTypeChart = echarts.init(document.getElementById('statisticsAppTypeChart'));
          // 绘制图表
          statisticsAppTypeChart.setOption({
            title: {
              text: '用户来源端比例',
              //主标题
              x: 'center',
              textStyle: {
                fontSize: '15'
              }
            },
            tooltip: {
              trigger: 'item'
            },
            series: [{
              name: '用户来源端比例',
              type: 'pie',
              radius: '50%',
              data: data,
              itemStyle: {
                emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }]
          });
        }).catch(function () {});
        // 用户性别比例
        getStatisticsByColumnUserInfo('sex', {}).then(function (response) {
          var data = response.data.data;
          data = data.map(function (item) {
            return {
              name: item.name == '0' ? '未知' : item.name == '1' ? '男' : item.name == '2' ? '女' : !item.name ? '未设置' : item.name,
              value: item.value
            };
          });
          // 基于准备好的dom，初始化echarts实例
          var statisticsSexChart = echarts.init(document.getElementById('statisticsSexChart'));
          // 绘制图表
          statisticsSexChart.setOption({
            title: {
              text: '用户性别比例',
              //主标题
              x: 'center',
              textStyle: {
                fontSize: '15'
              }
            },
            tooltip: {
              trigger: 'item'
            },
            series: [{
              name: '用户性别比例',
              type: 'pie',
              radius: '50%',
              data: data,
              itemStyle: {
                emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }]
          });
        }).catch(function () {});
        // 用户地区分布
        getStatisticsByColumnUserInfo('province', {}).then( /*#__PURE__*/function () {
          var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(response) {
            var data, statisticsProChart;
            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  echarts.registerMap("china", chinaMap);
                  data = response.data.data;
                  data = data.map(function (item) {
                    return {
                      name: item.name ? item.name.replace('省', '').replace('市', '') : '未知',
                      value: item.value
                    };
                  });
                  // 基于准备好的dom，初始化echarts实例
                  statisticsProChart = echarts.init(document.getElementById('statisticsProChart')); // 绘制图表
                  statisticsProChart.setOption({
                    title: {
                      text: '用户地区分布',
                      //主标题
                      x: 'center',
                      textStyle: {
                        fontSize: '15'
                      }
                    },
                    dataRange: {
                      x: 'right',
                      min: 0,
                      max: 1000,
                      text: ['高', '低'],
                      splitNumber: 0
                    },
                    tooltip: {
                      trigger: 'item'
                    },
                    series: [{
                      name: '用户地区分布',
                      type: 'map',
                      roam: false,
                      map: 'china',
                      selectedMode: 'multiple',
                      emphasis: {
                        label: {
                          show: true
                        }
                      },
                      data: data
                    }]
                  });
                case 5:
                case "end":
                  return _context.stop();
              }
            }, _callee);
          }));
          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }()).catch(function () {});
        // 订单来源端比例
        getStatisticsByColumnOrderInfo('app_type', {
          isPay: '1'
        }).then(function (response) {
          var data = response.data.data;
          data = data.map(function (item) {
            return {
              name: constantMall.clientType[item.name].title || item.name,
              value: item.value
            };
          });
          // 基于准备好的dom，初始化echarts实例
          var statisticsAppTypeChart = echarts.init(document.getElementById('statisticsAppTypeChart2'));
          // 绘制图表
          statisticsAppTypeChart.setOption({
            title: {
              text: '订单来源端比例',
              //主标题
              x: 'center',
              textStyle: {
                fontSize: '15'
              }
            },
            tooltip: {
              trigger: 'item'
            },
            series: [{
              name: '订单来源端比例',
              type: 'pie',
              radius: '50%',
              data: data,
              itemStyle: {
                emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }]
          });
        }).catch(function () {});
        //订单类型比例
        getStatisticsByColumnOrderInfo('order_type', {
          isPay: '1'
        }).then(function (response) {
          var data = response.data.data;
          data = data.map(function (item) {
            return {
              name: item.name == '0' ? '普通订单' : item.name == '1' ? '砍价订单' : item.name == '2' ? '拼团订单' : item.name == '3' ? '秒杀订单' : item.name,
              value: item.value
            };
          });
          // 基于准备好的dom，初始化echarts实例
          var statisticsAppTypeChart = echarts.init(document.getElementById('statisticsOrderTypeChart'));
          // 绘制图表
          statisticsAppTypeChart.setOption({
            title: {
              text: '订单类型比例',
              //主标题
              x: 'center',
              textStyle: {
                fontSize: '15'
              }
            },
            tooltip: {
              trigger: 'item'
            },
            series: [{
              name: '订单类型比例',
              type: 'pie',
              radius: '50%',
              data: data,
              itemStyle: {
                emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }]
          });
        }).catch(function () {});
      }
      if (this.userInfo.type == '2') {
        getStatisticsShopUser().then(function (response) {
          var data = response.data.data;
          _this4.option1.data[1].count = data.countToday;
          _this4.option1.data[1].allcount = data.countTotal;
        }).catch(function () {});
      }
      getStatisticsOrderInfo({
        isPay: '1'
      }).then(function (response) {
        var data = response.data.data;
        _this4.option1.data[2].count = data.countToday;
        _this4.option1.data[2].allcount = data.countTotal;
      }).catch(function () {});
    },
    getQrCode: function getQrCode() {
      var _this5 = this;
      getWxApp(this.wxApp.id).then(function (response) {
        _this5.dialogWxApp = false;
        _this5.wxApp = response.data.data;
        var qrUrl = _this5.h5HostMobile + '?app_id=' + _this5.wxApp.id + '&tenant_id=' + _this5.wxApp.tenantId;
        //第三方平台托管的需要加上component_appid
        if ('1' == _this5.wxApp.isComponent) {
          qrUrl = qrUrl + '&component_appid=' + _this5.wxApp.componentAppId;
        }
        _this5.dialogQrCode = true;
        _this5.qrCodeScene = qrUrl;
      }).catch(function () {});
    },
    //获取公众号h5二维码
    showWxH5Code: function showWxH5Code() {
      var _this6 = this;
      this.codeType = '2';
      this.wxApp = {};
      this.tableLoading = true;
      _getWxAppList({
        appType: '2'
      }).then(function (response) {
        _this6.tableLoading = false;
        var data = response.data;
        if (data && data.length > 0) {
          if (data.length == 1) {
            _this6.wxApp = data[0];
            _this6.getQrCode();
          } else {
            _this6.wxAppData = data;
            _this6.dialogWxApp = true;
          }
        } else {
          _this6.$message({
            showClose: true,
            message: '没有可选择的公众号，请先添加',
            type: 'error'
          });
        }
      }).catch(function () {
        _this6.tableLoading = false;
      });
    },
    showH5Url: function showH5Url() {
      var tenantId = this.userInfo.tenantId;
      if (this.userInfo.type == '-1') {
        tenantId = getStore({
          name: 'switchTenantId'
        });
      }
      var url = this.h5HostMobile + '?tenant_id=' + tenantId;
      this.$alert(url, '在手机普通浏览器中打开此链接', {
        confirmButtonText: '确定'
      });
    },
    //获取首页PC端页面地址
    showPCUrl: function showPCUrl() {
      var tenantId = this.userInfo.tenantId;
      if (this.userInfo.type == '-1') {
        tenantId = getStore({
          name: 'switchTenantId'
        });
      }
      var url = this.h5HostPC + '?tenant_id=' + tenantId;
      window.open(url);
    },
    //获取小程序码
    showMaCode: function showMaCode() {
      var _this7 = this;
      this.codeType = '1';
      this.tableLoading = true;
      this.wxApp = {};
      _getWxAppList({
        appType: '1'
      }).then(function (response) {
        _this7.tableLoading = false;
        var data = response.data;
        if (data && data.length > 0) {
          if (data.length == 1) {
            _this7.wxApp = data[0];
            _this7.getMaCode();
          } else {
            _this7.wxAppData = data;
            _this7.dialogWxApp = true;
          }
        } else {
          _this7.$message({
            showClose: true,
            message: '没有可选择的小程序，请先添加',
            type: 'error'
          });
        }
      }).catch(function () {
        _this7.tableLoading = false;
      });
    },
    getMaCode: function getMaCode() {
      var _this8 = this;
      _getMaCode({
        appId: this.wxApp.id,
        scene: "scene"
      }).then(function (response) {
        _this8.dialogWxApp = false;
        _this8.dialogQrCode = true;
        _this8.qrCodeScene = response.data.data;
      });
    },
    showAppUrl: function showAppUrl() {
      this.$alert('https://www.joolun.com/h-nd-108.html#_jcp=1', '请下载并安装App', {
        confirmButtonText: '确定'
      });
    }
  }
};